// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_n8-0";